 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"aicustomized~package":"aicustomized~package","aicustomized":"aicustomized","package":"package","ai-assistant":"ai-assistant","report":"report","user":"user","family":"family","goods":"goods","greenway":"greenway","health":"health","healthInsurance":"healthInsurance","medical":"medical","order":"order","org":"org","rights":"rights","notice":"notice","oppo-package":"oppo-package","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"chunk-141709b3":"1f425c5a","chunk-18b90d1c":"064b1d42","chunk-2c142fb4":"8a79758c","chunk-40483717":"e22355c7","chunk-41c2028e":"e44252bc","chunk-478de8fc":"69767d7f","chunk-9f4c1832":"cb5afbe7","chunk-3897a6ca":"50b93861","chunk-3921d1c6":"b1a3de7a","chunk-3f375cf2":"30f1036c","aicustomized~package":"2664a4bd","aicustomized":"d9f696db","package":"b4af675d","chunk-13846f5f":"0cef30dd","ai-assistant":"df382fd1","chunk-874a10c4":"db75d467","chunk-47290efa":"20898eb9","report":"214b2ee8","chunk-3d35c898":"52ef0c45","chunk-5eab601a":"8e55b5fb","chunk-70f9b6dc":"f432db5d","chunk-8d01fd28":"104e7388","chunk-aff765e6":"3be0bb4e","chunk-1c8fb274":"c579f477","chunk-69ac8fe4":"7c212730","user":"816db9ac","family":"dd6104cb","goods":"b84767be","greenway":"306ba76e","health":"c9980382","healthInsurance":"05915427","medical":"85635f8d","order":"f5e40fbb","org":"cce3f546","rights":"354e4c6b","chunk-b7911cb2":"78b127aa","chunk-cb3fb368":"f0f1c3a7","chunk-f8a66012":"c7aa40d3","notice":"62e37e49","oppo-package":"4a998d32","pdfjsWorker":"dd4ec650"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-141709b3":1,"chunk-18b90d1c":1,"chunk-2c142fb4":1,"chunk-40483717":1,"chunk-41c2028e":1,"chunk-478de8fc":1,"chunk-9f4c1832":1,"chunk-3897a6ca":1,"chunk-3921d1c6":1,"chunk-3f375cf2":1,"aicustomized~package":1,"aicustomized":1,"package":1,"chunk-13846f5f":1,"ai-assistant":1,"chunk-874a10c4":1,"chunk-47290efa":1,"report":1,"chunk-3d35c898":1,"chunk-5eab601a":1,"chunk-70f9b6dc":1,"chunk-8d01fd28":1,"chunk-aff765e6":1,"chunk-1c8fb274":1,"chunk-69ac8fe4":1,"user":1,"family":1,"goods":1,"greenway":1,"health":1,"healthInsurance":1,"medical":1,"order":1,"org":1,"rights":1,"chunk-b7911cb2":1,"chunk-cb3fb368":1,"chunk-f8a66012":1,"notice":1,"oppo-package":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"aicustomized~package":"aicustomized~package","aicustomized":"aicustomized","package":"package","ai-assistant":"ai-assistant","report":"report","user":"user","family":"family","goods":"goods","greenway":"greenway","health":"health","healthInsurance":"healthInsurance","medical":"medical","order":"order","org":"org","rights":"rights","notice":"notice","oppo-package":"oppo-package","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"chunk-141709b3":"05ae6422","chunk-18b90d1c":"3ccf61a7","chunk-2c142fb4":"93e61f60","chunk-40483717":"c5b9cd31","chunk-41c2028e":"6eb1264f","chunk-478de8fc":"cb3b19fb","chunk-9f4c1832":"a489dc56","chunk-3897a6ca":"900d9426","chunk-3921d1c6":"dfe1e43a","chunk-3f375cf2":"e5c5f758","aicustomized~package":"755bc02a","aicustomized":"5a548bdc","package":"c27b142c","chunk-13846f5f":"453a1daa","ai-assistant":"c16c139b","chunk-874a10c4":"985b4052","chunk-47290efa":"d43feaeb","report":"13c43f22","chunk-3d35c898":"1b523ab7","chunk-5eab601a":"44a55fcf","chunk-70f9b6dc":"1dc77442","chunk-8d01fd28":"92e53b2e","chunk-aff765e6":"f78031a0","chunk-1c8fb274":"90ac5a9f","chunk-69ac8fe4":"d9f780b7","user":"5edc9601","family":"f8c9111d","goods":"04f89792","greenway":"5fb9ddde","health":"d519fd21","healthInsurance":"8d7f3945","medical":"7d2212d0","order":"b6c18748","org":"cfdb4bc5","rights":"c89327eb","chunk-b7911cb2":"36c1fe8c","chunk-cb3fb368":"3a3c3381","chunk-f8a66012":"7f435d11","notice":"18bcc494","oppo-package":"aa50c77b","pdfjsWorker":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
